import "./anexoI1.scss";
import DatePicker from "react-datepicker";
import Titulo from "../../components/atoms/titles/Titulo";
import { Formik, Form, ErrorMessage, Field } from "formik";
import { useEffect, useState } from "react";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import Header from "../../components/molecules/header/Header";
import {
  getDatosDestinoPorDNI,
  insertSolicitudConcursoAnexoI1,
  obtenerLocalidades,
  obtenerProvincias,
  obtenerSolicitudPorCod,
  updateSolicitudConcursoAnexoI1,
} from "../../components/services/ConcursosService";
import {
  SpinnerCircle,
  SpinnerCircleMini,
} from "../../components/atoms/spinner/Spinner";
import { getDatosGrupoL } from "../../components/services/Anexoi1Service";
import { useParams } from "react-router-dom";
import IfError from "../../components/molecules/ifError/IfError";
import Footer from "../../components/molecules/footer/Footer";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { signal } from "@preact/signals-react";

const AnexoI1 = () => {
  const datosActual = signal([]);
  const params = useParams();
  const [grupoProf, setGrupoProf] = useState("");
  const [disableGuardar, setDisableGuardar] = useState(false);
  const [disableMunicipio, setDisableMunicipio] = useState(true);
  const [municipios, setMunicipios] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [datosGrupo, setDatosGrupo] = useState([]);
  const [catEsp, setCatEsp] = useState([]);
  const [startDate, setStartDate] = useState();
  const [checkDatos, setCheckDatos] = useState(true);
  const [cargaBoton, setCargaBoton] = useState(false);
  const [datosDestino, setDatosDestino] = useState(false);
  const [mostrarDA, setMostrarDA] = useState(
    params?.idol !== null || params?.idol !== undefined ? true : false
  );
  const [disableGrupo, setDisableGrupo] = useState(false);

  const [user] = useLocalStorage("user", "");

  const [show, setShow] = useState({
    mensaje: false,
  });

  const handleClose = (e) => {
    setShow(false);
  };

  const handleProvincia = (e) => {
    setDisableMunicipio(true);
    
    setDatos((prevState) => ({
      ...prevState,
      loccprovincia: e.target.selectedOptions[0].value,
    }));
    obtenerLocalidades(e.target.value).then((data) => {
      

      // setMunicipios(data);
      // setDisableMunicipio(false);
      // setDatos((prevState) => ({
      //   ...prevState,
      //   loccmunicipio: data[0].id,
      // }));
    });
  };
  const handleGrupoProf = (e) => {
    setGrupoProf(e.target.selectedOptions[0].value);
    setCatEsp(
      datosGrupo.filter(
        (data) => data.cgrppro === e.target.selectedOptions[0].value
      )
    );
    
    setDatos((prevState) => ({
      ...prevState,
      cgrppro: e.target.selectedOptions[0].value,
      grppro: e.target.selectedOptions[0].text,
    }));
  };

  const handleEspecialidad = (e) => {
    setMostrarDA(false);
    getDatosDestinoPorDNI().then((data) => {
      

      if (datosDestino === false) {
        datosActual.value = data[0];
        setMostrarDA(true);
        
        setDatosDestino(data[0])
      }
    });

    //datos destino
    // getDatosDestinoPorDNI(user.niep).then((data) => {
    //   
    //   setDatosDestino(datosDestinoTemporal);
    //   setMostrarDA(true);

    //   setStartDate(new Date(data.fefepos));
    //   setDatos((prevState) => ({
    //     ...prevState,
    //     ccatpro: e.target.selectedOptions[0].value,
    //     cateEspeda: datosDestino.dcatpro,
    //   }));
    //   setDisableGuardar(true);
    // });
  };
  const handleMunicipio = (e) => {
    setDatos((prevState) => ({
      ...prevState,
      loccmunicipio: e.target.selectedOptions[0].value,
    }));
  };
  const comprobarDatos = (errors) => {
    if (
      Object.keys(errors).length === 0 &&
      datos?.loccmunicipio !== null &&
      datos?.loccmunicipio !== "" &&
      datos?.loccprovincia !== null &&
      datos?.loccprovincia !== "" &&
      datos?.cgrppro !== null &&
      datos?.cgrppro !== "" &&
      datos?.cuerpoEscala !== null &&
      datos?.ccatpro !== null &&
      datos?.ccatpro !== ""
    ) {
      setCargaBoton(false);
      return true;
    } else {
      return false;
    }
  };
  const [datos, setDatos] = useState({
    xsolicitud: 0,
    codconcurso: 0,

    dsolicitud: "",
    tipiep: "",
    vvalidada: "N",

    letiniiep: "",
    niep: "",
    letfiniep: "",
    nombre: "",
    apellido1: "",
    apellido2: "",
    ntelefono: "",
    ntelefono2: "",
    temail: "",
    dtipvia: null,
    dcalle: "",
    ncalle: "",
    lbis: "N",
    escalera: "",
    npiso: "",
    puerta: "",
    cpostal: "",
    loccpais: 724,
    loccprovincia: "",
    loccmunicipio: "",
    locclocalidad: "",

    norden: "",
    lobligado: "",
    admcadmacc: null, //Posible FK para tabla administradores
    loap: "N",

    cgrppro: "",
    grppro: "",
    ccatpro: "",
    especialidad: "",
    sitcsituacion: "",
    dsituacion: "",
    lcondic: "N",

    puestoda: "",
    cateEspeda: "",
    grupoprofda: "",
    nivelda: "",
    consejeriada: "",
    centrodirectivoda: "",
    localidadda: "",
    ocupacionda: "",
    posesionda: "",

    fpresentacion: null,
    fregistro: null,
    fmodificacion: null,
    modificado: "AE_AREAPERSONAL",
    fcreacion: "",
    creado: "AE_AREAPERSONAL",
  });

  useEffect(() => {
    
    if (params?.idsol === null || params?.idsol === undefined) {
      setCheckDatos();
      setDatos((prevState) => ({
        ...prevState,
        apellido1: user.apellido1,
        apellido2: user.apellido2,
        nombre: user.nombre,
        niep: `${user.niep}`,
        letfiniep: `${user.letniep}`,
      }));
      //datos grupo
      getDatosGrupoL().then((data) => {
        
        setDatosGrupo(data);
      });
    } else {
      obtenerSolicitudPorCod(params.idsol).then((data) => {
        
        getDatosGrupoL().then((dataGrupo) => {
          setDatosGrupo(dataGrupo);
          
          setCatEsp(dataGrupo);
          setDisableGrupo(true);

          if (!data.toString().startsWith("Error:")) {
            // getDatosDestinoPorSolicitud(params?.idsol).then((data) => {
            //   
            //   setDatosDestino(data);
            //   setStartDate(new Date(data.fefepos));
            // });
            setCheckDatos(false);
            setDatos((prevState) => ({
              ...prevState,
              dsolicitud: data?.dSolicitud === null ? "" : data?.dSolicitud,
              niep: data?.niep === null ? "" : data?.niep,
              letfiniep: data?.letfiniep === null ? "" : data?.letfiniep,
              letiniiep: data?.letiniiep === null ? "" : data?.letiniiep,
              apellido1: data?.apellido1 === null ? "" : data?.apellido1,
              apellido2: data?.apellido2 === null ? "" : data?.apellido2,
              nombre: data?.nombre === null ? "" : data?.nombre,
              ntelefono: data?.nTelefono === null ? "" : data?.nTelefono,
              ntelefono2: data?.nTelefono2 === null ? "" : data?.nTelefono2,
              temail: data?.tEmail === null ? "" : data?.tEmail,
              dcalle: data?.dCalle === null ? "" : data?.dCalle,
              ncalle: data?.nCalle === null ? "" : data?.nCalle,
              lbis: data?.lBis === null ? "" : data?.lBis,
              escalera: data?.escalera === null ? "" : data?.escalera,
              npiso: data?.nPiso === null ? "" : data?.nPiso,
              puerta: data?.puerta === null ? "" : data?.puerta,
              cpostal: data?.cPostal === null ? "" : data?.cPostal,
              locclocalidad:
                data?.locClocalidad === null ? "" : data?.locClocalidad,
              loccprovincia:
                data?.locCprovincia === null ? "" : data?.locCprovincia,
              loccmunicipio:
                data?.locCmunicipio === null ? "" : data?.locCmunicipio,
              loccpais: data?.locCpais === null ? "" : data?.locCpais,
              norden:
                data?.nOrden === null || data?.nOrden === undefined
                  ? ""
                  : data?.nOrden,
              lobligado: data?.lObligado === null ? "" : data?.lObligado,

              //EL GRUPO y Categoría/Especialidad
              //NO SE AUTO RELLENA POR QUE ES
              //UN POCO LIO, SI HAY QUE AÑADIRLO,
              //SE AÑADE, PERO POR AHORA SE QUEDA ASÍ

              cgrppro: dataGrupo[0].grppro,
              ccatpro: dataGrupo[0].especialidad,
              sitcsituacion: dataGrupo[0].dsituacion,

              lcondic: data?.lCondic === null ? "" : data?.lCondic,

              puestoda: data?.puestoda === null ? "" : data?.puestoda,
              cateEspeda: data?.cateEspeda === null ? "" : data?.cateEspeda,
              grupoprofda: data?.grupoprofda === null ? "" : data?.grupoprofda,
              nivelda: data?.nivelda === null ? "" : data?.nivelda,
              consejeriada:
                data?.consejeriada === null ? "" : data?.consejeriada,
              centrodirectivoda:
                data?.centrodirectivoda === null ? "" : data?.centrodirectivoda,
              localidadda: data?.localidadda === null ? "" : data?.localidadda,
              ocupacionda: data?.ocupacionda === null ? "" : data?.ocupacionda,
              posesionda: data?.posesionda === null ? "" : data?.posesionda,
            }));

            if (
              data.locCpais &&
              data.locCprovincia &&
              data.locCmunicipio &&
              data.locClocalidad
            ) {
              obtenerLocalidades(data?.locCprovincia).then((dataLoc) => {
                setMunicipios(dataLoc);
                if (
                  data.locCpais &&
                  data.locCprovincia &&
                  data.locCmunicipio &&
                  data.locClocalidad &&
                  dataLoc
                )
                  setDisableMunicipio(false);
              });
            }
          } else {
            setDatos(data);
            setCheckDatos(true);
          }
        });
      });
    }

    if (!checkDatos) {
      obtenerProvincias().then((data) => {
        setLocalidades(data);
        setLoading(true);
      });
    }
  }, [checkDatos, params, user]);

  //obtiene la fecha de hoy para la fecha de toma de posesión
  const date = new Date();
  const futureDate = date.getDate();
  date.setDate(futureDate);

  //Lugar, Fecha y Firma
  const fechaHoy = new Date();
  const opcionesFecha = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  const formatoFecha = new Intl.DateTimeFormat('es-ES', opcionesFecha);
  const fechaFormateada = formatoFecha.format(fechaHoy).replace(/de/g, '').replace(/(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/g, (match) => match.charAt(0).toUpperCase() + match.slice(1));

  return (
    <>
      <Header></Header>
      <div
        className="container d-flex flex-column min-vh-100 card mt-5"
        id="inicio"
      >
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login">
                <div className="tituloSolicitud">
                  <Titulo titulo={"Anexo I.1"} tipo={"tituloPagina"} />
                  <div className="d-flex align-items-center flex-column">
                    <Titulo
                      titulo={"SOLICITUD DE PARTICIPACIÓN"}
                      tipo={"tituloPagina subTituloPagina"}
                    />
                    <span className="rojo">{datos.estado}</span>
                  </div>
                  <span className="p-3 rojo">Campo obligatorio *</span>
                  <div className="datosPersonales d-flex flex-column">
                    <div className="formulario">
                      <Formik
                        defaultValue={{}}
                        initialValues={{
                          dsolicitud:
                            datos.dsolicitud === "" ? "" : datos.dsolicitud,
                          niep: datos.niep === "" ? "" : datos.niep,
                          letfiniep:
                            datos.letfiniep === "" ? "" : datos.letfiniep,
                          letiniiep:
                            datos.letiniiep === "" ? "" : datos.letiniiep,
                          nombre: datos.nombre === "" ? "" : datos.nombre,
                          apellido1:
                            datos.apellido1 === "" ? "" : datos.apellido1,
                          apellido2:
                            datos.apellido2 === "" ? "" : datos.apellido2,
                          ntelefono:
                            datos.ntelefono === "" ? "" : datos.ntelefono,
                          ntelefono2:
                            datos.ntelefono2 === "" ? "" : datos.ntelefono2,
                          temail: datos.temail === "" ? "" : datos.temail,
                          dcalle: datos.dcalle === "" ? "" : datos.dcalle,
                          ncalle: datos.ncalle === "" ? "" : datos.ncalle,
                          lbis: datos.lbis === "S" ? true : false,
                          escalera: datos.escalera === "" ? "" : datos.escalera,
                          npiso: datos.npiso === "" ? "" : datos.npiso,
                          puerta: datos.puerta === "" ? "" : datos.puerta,
                          cpostal: datos.cpostal === "" ? "" : datos.cpostal,
                          loccprovincia:
                            datos.loccprovincia === ""
                              ? ""
                              : datos.loccprovincia,
                          loccmunicipio:
                            datos.loccmunicipio === ""
                              ? ""
                              : datos.loccmunicipio,
                          norden: datos.norden === "" ? "" : datos.norden,
                          cgrppro: datos.cgrppro === "" ? "" : datos.cgrppro,
                          lobligado: datos.lobligado === "S" ? "S" : "N",
                          ccatpro: datos.ccatpro === "" ? "" : datos.ccatpro,
                          lcondic: datos.lcondic === "S" ? "S" : "N",

                          sitcsituacion:
                            datosDestino.dsituacion === ""
                              ? ""
                              : datosDestino.dsituacion,

                          puestoda:
                            datosDestino.xpt === "" || datosDestino.xpt === null
                              ? ""
                              : datosDestino.xpt,
                          cateEspeda:
                            datosDestino.dcatpro === "" ||
                              datosDestino.dcatpro === null
                              ? ""
                              : datosDestino.dcatpro,
                          grupoprofda:
                            datosDestino.grppro === "" ||
                              datosDestino.grppro === null
                              ? ""
                              : datosDestino.grppro,
                          nivelda:
                            datosDestino.cnivel === "" ||
                              datosDestino.cnivel === null
                              ? ""
                              : datosDestino.cnivel,
                          consejeriada:
                            datosDestino.consejeria === "" ||
                              datosDestino.consejeria === null
                              ? ""
                              : datosDestino.consejeria,
                          centrodirectivoda:
                            datosDestino.centrodir === "" ||
                              datosDestino.centrodir === null
                              ? ""
                              : datosDestino.centrodir,
                          localidadda:
                            datosDestino.daregeo === "" ||
                              datosDestino.daregeo === null
                              ? ""
                              : datosDestino.daregeo,
                          ocupacionda:
                            datosDestino.dcarocu === "" ||
                              datosDestino.dcarocu === null
                              ? ""
                              : datosDestino.dcarocu,
                          posesionda:
                            datosDestino.fefepos === "" ||
                              datosDestino.fefepos === null
                              ? ""
                              : datosDestino.fefepos,
                        }}
                        validate={(valores) => {
                          const errores = {};
                          
                          if (
                            valores.dsolicitud === null ||
                            valores.dsolicitud === ""
                          ) {
                            errores.dsolicitud =
                              "Debe introducir una descripción.";
                          }
                          if (valores.niep !== null || valores.niep !== "") {
                            let regex = /^\d{8}$/;
                            let result = regex.test(valores.niep);
                            if (!result) {
                              errores.niep = "Debe introducir un DNI válido.";
                            }
                          }
                          if (
                            valores.letfiniep !== null ||
                            valores.letfiniep !== ""
                          ) {
                            let regex = /^[a-zA-Z]$/;
                            let result = regex.test(valores.letfiniep);
                            if (!result) {
                              errores.letfiniep =
                                "Debe introducir la letra DNI.";
                            }
                          }
                          if (
                            valores.nombre === null ||
                            valores.nombre === ""
                          ) {
                            errores.nombre = "Debe introducir un nombre.";
                          }
                          if (
                            valores.apellido1 === null ||
                            valores.apellido1 === ""
                          ) {
                            errores.apellido1 =
                              "Debe introducir el primer apellido.";
                          }
                          if (
                            valores.apellido2 === null ||
                            valores.apellido2 === ""
                          ) {
                            errores.apellido2 =
                              "Debe introducir el segundo apellido.";
                          }
                          if (
                            (valores.domicilio === null ||
                              valores.domicilio === "") &&
                            valores.domicilio !== "S/N"
                          ) {
                            errores.domicilio =
                              "Debe introducir un domicilio o poner S/N.";
                          }
                          if (
                            !/^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/.test(
                              valores.cpostal.toString()
                            )
                          ) {
                            errores.cpostal =
                              "Debe introducir un Código Postal.";
                          }
                          if (
                            valores.ncalle === null ||
                            valores.ncalle === ""
                          ) {
                            errores.ncalle =
                              "Debe introducir un número de calle.";
                          }
                          if (
                            valores.dcalle === null ||
                            valores.dcalle === ""
                          ) {
                            errores.dcalle = "Debe introducir una calle.";
                          }
                          if (
                            !/\(?([0-9]{3})\)?([ -]?)([0-9]{3})\2([0-9]{3})$/.test(
                              valores.ntelefono
                            )
                          ) {
                            errores.ntelefono =
                              "Debe introducir un teléfono Fijo.";
                          }
                          if (
                            valores.temail === null ||
                            valores.temail === ""
                          ) {
                            errores.temail =
                              "Debe introducir un correco electrónico.";
                          }
                          if (
                            valores.norden === null ||
                            valores.norden === ""
                          ) {
                            errores.norden =
                              "Debe introducir un Orden de Preferencia.";
                          }
                          setDisableGuardar(true);
                          return errores;
                        }}
                        onSubmit={(valores) => {
                          const errors = {};
                          setCargaBoton(true);
                          if (comprobarDatos(errors)) {
                            
                            valores.loccprovincia = datos.loccprovincia;
                            valores.loccmunicipio = datos.loccmunicipio;
                            valores.cgrppro = datos.cgrppro;
                            valores.grppro = datos.grppro;
                            valores.ccatpro = datos.ccatpro;
                            valores.especialidad = datos.especialidad;
                            valores.codconcurso = params?.idcon;

                            valores.tipiep = "";
                            valores.dtipvia = null;
                            valores.vvalidada = "N";
                            valores.loccpais = 724;
                            valores.admcadmacc = null;
                            valores.loap = "N";
                            valores.dsituacion = ""; //todo: recoger del select de situación administrativa cuando esté
                            valores.fpresentacion = null;
                            valores.fregistro = null;
                            valores.fmodificacion = null;
                            valores.modificado = "AE_AREAPERSONAL";
                            valores.fcreacion = "";
                            valores.creado = "AE_AREAPERSONAL";

                            valores.posesionda = startDate.toLocaleString(
                              "es",
                              {
                                dateStyle: "short",
                              }
                            ); //no quitar
                            valores.lbis =
                              valores.lbis === true || valores.lbis === "S"
                                ? "S"
                                : "N";
                            
                            if (
                              params?.idsol === null ||
                              params?.idsol === undefined
                            ) {
                              insertSolicitudConcursoAnexoI1(valores).then(
                                (data) => {
                                  setShow({
                                    mensaje: true,
                                    content: data,
                                    tipo: "tituloModal",
                                    destinoCerrar: null,
                                  });
                                }
                              );
                              setCargaBoton(false);
                            } else {
                              updateSolicitudConcursoAnexoI1(
                                valores,
                                params?.idsol
                              ).then((data) => {
                                setShow({
                                  mensaje: true,
                                  content: data,
                                  tipo: `tituloModal ${data.startsWith("Error:") ? "rojo" : ""
                                    }`,
                                  destinoCerrar: null,
                                });
                              });
                              setCargaBoton(false);
                            }
                          }
                        }}
                      >
                        {({ errors }) => (
                          <>
                            <Form>
                              {params?.idsol === null ||
                                params?.idsol === undefined ? (
                                <>
                                  <div className="descripcion p-2 d-flex flex-column">
                                    <label htmlFor="dsolicitud">
                                      Descripción de su solicitud
                                      <span className="rojo"> *</span>:
                                      <i
                                        className="fa-regular fa-circle-question ms-2 cursorPointer"
                                        onClick={() => {
                                          setShow({
                                            mensaje: true,
                                            otherContent:
                                              'Ponga nombre a su solicitud para poder identificar el fichero electrónico; es texto libre, escriba lo que quiera: p.e. "Concurso 1"',
                                            tipo: "tituloModal",
                                          });
                                        }}
                                      ></i>
                                    </label>

                                    <div className="d-flex ">
                                      <Field
                                        type="text"
                                        id="dsolicitud"
                                        name="dsolicitud"
                                        className="form-control ms-2"
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="dsolicitud"
                                      component={() => (
                                        <div className="error rojo pt-2 ps-2">
                                          {errors.dsolicitud}
                                        </div>
                                      )}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="descripcion p-2 d-flex">
                                    <label htmlFor="dsolicitud">
                                      Descripción de su solicitud :
                                    </label>

                                    <div className="d-flex ">
                                      <p className="fw-bold ps-1">
                                        {" "}
                                        {`${datos.dsolicitud}`}
                                      </p>
                                    </div>
                                  </div>
                                </>
                              )}

                              <div className="infoSolicitud">
                                <div className="instrucciones">
                                  <p className="my-3 mx-2">
                                    El personal laboral cuyos datos figuran a
                                    continuación SOLICITA:
                                  </p>
                                </div>
                              </div>
                              <div>
                                <div className="d-flex justify-content-between">
                                  <Titulo
                                    clases={"subSubTituloSolicitud p-2 fw-bold"}
                                    tipo={"tituloCard noBg"}
                                    titulo={"1. Datos del Participante"}
                                  ></Titulo>
                                </div>
                              </div>

                              <div className="formularioDatosPesonalesI1 p-2">
                                <div className="datosDNIi1 m-1">
                                  <label htmlFor="niep">DNI o Pasaporte:</label>
                                  <div className="d-flex">
                                    <Field
                                      type="text"
                                      id="letiniiep"
                                      name="letiniiep"
                                      className="form-control m-1 w-25"
                                      maxLength="1"
                                      disabled
                                    />
                                    <Field
                                      type="text"
                                      id="niep"
                                      name="niep"
                                      className="form-control m-1"
                                      disabled
                                    />
                                    <Field
                                      type="text"
                                      id="letfiniep"
                                      name="letfiniep"
                                      className="form-control m-1 w-25"
                                      maxLength="1"
                                      disabled
                                    />
                                  </div>
                                  <ErrorMessage
                                    name="letfiniep"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.letfiniep}
                                      </div>
                                    )}
                                  />
                                  <ErrorMessage
                                    name="niep"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.niep}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="ape1i1 m-2">
                                  <label htmlFor="apellido1">
                                    Primer apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="apellido1"
                                    name="apellido1"
                                    className="form-control"
                                    disabled
                                  />
                                  <ErrorMessage
                                    name="apellido1"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.apellido1}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="ape2i1 m-2">
                                  <label htmlFor="apellido2">
                                    Segundo apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="apellido2"
                                    name="apellido2"
                                    className="form-control"
                                    disabled
                                  />
                                  <ErrorMessage
                                    name="apellido2"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.apellido2}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="nombrei1 m-2">
                                  <label htmlFor="nombre">
                                    Nombre <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    className="form-control"
                                  />
                                  <ErrorMessage
                                    name="nombre"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.nombre}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="tlfFijoi1 m-2">
                                  <label htmlFor="ntelefono">
                                    Teléfono fijo{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="ntelefono"
                                    name="ntelefono"
                                    className="form-control"
                                  />
                                  <ErrorMessage
                                    name="ntelefono"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.ntelefono}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="tlfMovili1 m-2">
                                  <label htmlFor="ntelefono2">
                                    Teléfono móvil:
                                  </label>
                                  <Field
                                    type="text"
                                    id="ntelefono2"
                                    name="ntelefono2"
                                    className="form-control"
                                  />
                                </div>
                                <div className="emaili1 m-2">
                                  <label htmlFor="temail">
                                    Correo electrónico{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="temail"
                                    id="temail"
                                    name="temail"
                                    className="form-control"
                                  />
                                  <ErrorMessage
                                    name="temail"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.temail}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="viai1 m-2">
                                  <label htmlFor="dcalle">
                                    Calle <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="dcalle"
                                    name="dcalle"
                                    className="form-control"
                                  />
                                  <ErrorMessage
                                    name="dcalle"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.dcalle}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="numeroBisi1 m-2">
                                  <div className="numero">
                                    <label htmlFor="ncalle">
                                      Nº <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ncalle"
                                      name="ncalle"
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="bis d-flex align-items-center justify-content-center">
                                    <label htmlFor="lbis">Bis:</label>{" "}
                                    <Field
                                      type="checkbox"
                                      id="lbis"
                                      name="lbis"
                                      className="form-check-input"
                                    />
                                  </div>
                                  <div className="mensajeNumeroBis">
                                    <ErrorMessage
                                      name="ncalle"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.ncalle}
                                        </div>
                                      )}
                                    />
                                  </div>
                                </div>
                                <div className="escalerai1 m-2">
                                  <label htmlFor="escalera">Escalera:</label>
                                  <Field
                                    type="text"
                                    id="escalera"
                                    name="escalera"
                                    className="form-control"
                                  />
                                </div>
                                <div className="pisoi1 m-2">
                                  <label htmlFor="npiso">Piso:</label>
                                  <Field
                                    type="text"
                                    id="npiso"
                                    name="npiso"
                                    className="form-control"
                                  />
                                </div>
                                <div className="puertai1 m-2">
                                  <label htmlFor="puerta">Puerta:</label>
                                  <Field
                                    type="text"
                                    id="puerta"
                                    name="puerta"
                                    className="form-control"
                                  />
                                </div>
                                <div className="cpi1 m-2">
                                  <label htmlFor="cpostal">
                                    CP <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="cpostal"
                                    name="cpostal"
                                    className="form-control"
                                  />
                                  <ErrorMessage
                                    name="cpostal"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.cpostal}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="localidad m-2">
                                  <label htmlFor="loccmunicipio">
                                    Municipio <span className="rojo">*</span>:
                                  </label>
                                  {disableMunicipio &&
                                    datos.loccprovincia !== "" ? (
                                    <>
                                      <SpinnerCircleMini></SpinnerCircleMini>
                                    </>
                                  ) : (
                                    <>
                                      
                                      <select
                                        name="loccmunicipio"
                                        id="loccmunicipio"
                                        className="form-select"
                                        onChange={handleMunicipio}
                                        defaultValue={`${datos?.cpais}-${datos?.loccprovincia}-${datos?.loccmunicipio}-${datos?.locclocalidad}`}
                                        disabled={disableMunicipio}
                                      >
                                        <option value="" disabled>
                                          Seleccione una opción
                                        </option>
                                        {municipios.map((municipio, i) => (
                                          <option
                                            value={`${municipio.cpais}-${municipio.cprovincia}-${municipio.cmunicipio}-${municipio.clocalidad}`}
                                            key={i}
                                            defaultValue={
                                              municipio.id ===
                                                datos.loccmunicipio
                                                ? true
                                                : false
                                            }
                                          >
                                            {municipio.dlocalidad}
                                          </option>
                                        ))}
                                      </select>
                                    </>
                                  )}
                                  {(datos?.loccmunicipio === null ||
                                    datos?.loccmunicipio === "") &&
                                    !disableGuardar ? (
                                    <>
                                      <div className="error rojo pt-2">
                                        Debe seleccionar un Municipio.
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                                <div className="provincia m-2">
                                  <label htmlFor="loccprovincia">
                                    Provincia <span className="rojo">*</span>:
                                  </label>
                                  <select
                                    name="loccprovincia"
                                    id="loccprovincia"
                                    className="form-select"
                                    onChange={handleProvincia}
                                    defaultValue={
                                      datos?.loccprovincia !== ""
                                        ? datos?.loccprovincia
                                        : ""
                                    }
                                  >
                                    <option value={""} disabled>
                                      Seleccione una opción
                                    </option>
                                    {localidades.map((localidad, i) => (
                                      <option
                                        value={localidad.id}
                                        key={i}
                                        defaultValue={
                                          localidad.id === datos.loccprovincia
                                            ? true
                                            : false
                                        }
                                      >
                                        {localidad.value}
                                      </option>
                                    ))}
                                  </select>
                                  {(datos?.loccprovincia === null ||
                                    datos?.loccprovincia === "") &&
                                    !disableGuardar ? (
                                    <>
                                      <div className="error rojo pt-2">
                                        Debe seleccionar una provincia.
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              </div>

                              <Titulo
                                clases={"subSubTituloSolicitud p-2 fw-bold"}
                                tipo={"tituloCard noBg"}
                                titulo={"2. Datos de participación"}
                              ></Titulo>

                              <div className="datosParticipacion">
                                <div className="ordenPref m-2">
                                  <label htmlFor="norden">
                                    Orden de preferencia de la solicitud{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="norden"
                                    name="norden"
                                    className="form-control"
                                  />
                                  <ErrorMessage
                                    name="norden"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.norden}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="grupoProf m-2">
                                  <label htmlFor="cgrppro">
                                    Grupo profesional{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                             
                                  <select
                                    name="cgrppro"
                                    id="cgrppro"
                                    className="form-select"
                                    onChange={handleGrupoProf}
                                    disabled={disableGrupo}
                                    defaultValue={
                                      params?.idsol !== null ||
                                        params?.idsol !== undefined
                                        ? datos.cgrppro !== null ||
                                          datos.cgrppro !== undefined
                                          ? datos.cgrppro
                                          : ""
                                        : ""
                                    }
                                  >
                                    <option value="" disabled>
                                      Seleccione una opción
                                    </option>
                                    {datosGrupo.map((grupoProf, i) => (
                                      <option value={grupoProf.cgrppro} key={i}>
                                        {grupoProf.grppro}
                                      </option>
                                    ))}
                                  </select>
                                  {datos?.cgrppro === null ||
                                    datos?.cgrppro === "" ? (
                                    <>
                                      <div className="error rojo pt-2">
                                        Debe seleccionar un grupo profesional.
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                                <div className="obliga m-2 d-flex justify-content-between flex-column">
                                  <div className="checkGrid">
                                    <div className="checkTit">
                                      <label htmlFor="lobligado">
                                        ¿Está obligado a concursar?:
                                      </label>
                                    </div>
                                    <div className="checkOpc1">
                                      <div className="form-check">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="lobligado"
                                          id="obligaSi"
                                          value="S"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="obligaSi"
                                        >
                                          Si
                                        </label>
                                      </div>
                                    </div>
                                    <div className="checkOpc2">
                                      <div className="form-check">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="lobligado"
                                          id="obligaNo"
                                          value="N"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="obligaNo"
                                        >
                                          No
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="categoria m-2">
                                  <label htmlFor="categoria">
                                    Categoría/Especialidad{" "}
                                    {!datos?.cgrppro === "" ? (
                                      <>
                                        <span className="rojo">*</span>
                                      </>
                                    ) : null}
                                    :
                                  </label>
                                  <select
                                    name="ccatpro"
                                    id="ccatpro"
                                    className="form-select"
                                    onChange={handleEspecialidad}
                                    disabled={grupoProf === ""}
                                    defaultValue={
                                      params?.idsol !== null ||
                                        params?.idsol !== undefined
                                        ? datos.ccatpro !== null ||
                                          datos.ccatpro !== undefined
                                          ? datos.ccatpro
                                          : ""
                                        : ""
                                    }
                                  >
                                    <option value="" disabled>
                                      Seleccione una opción
                                    </option>
                                    {}
                                    {catEsp.map((categoria, i) => (
                                      <option value={categoria.ccatpro} key={i}>
                                        {categoria.especialidad}
                                      </option>
                                    ))}
                                  </select>
                                  {datos?.ccatpro === null ||
                                    datos?.ccatpro === "" ? (
                                    <>
                                      <div className="error rojo pt-2">
                                        Debe seleccionar una categoría.
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                                <div className="derecho m-2 d-flex justify-content-between flex-column">
                                  <div className="checkGrid">
                                    <div className="checkTit">
                                      <label htmlFor="lcondic">
                                        ¿Derecho preferente?:
                                      </label>
                                    </div>

                                    <div className="checkOpc1">
                                      <div className="form-check">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="lcondic"
                                          id="derechoSi"
                                          value="S"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="derechoSi"
                                        >
                                          Si
                                        </label>
                                      </div>
                                    </div>
                                    <div className="checkOpc2">
                                      <div className="form-check">
                                        <Field
                                          className="form-check-input"
                                          type="radio"
                                          name="lcondic"
                                          id="derechoNo"
                                          value="N"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="derechoNo"
                                        >
                                          No
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="sitAdmin m-2">
                                  <label htmlFor="sitcsituacion">
                                    Situación administrativa:
                                  </label>
                                  <Field
                                    type="text"
                                    id="sitcsituacion"
                                    name="sitcsituacion"
                                    className="form-control"
                                    readOnly
                                    disabled
                                  />
                                </div>
                              </div>

                              <Titulo
                                clases={"subSubTituloSolicitud p-2 fw-bold"}
                                tipo={"tituloCard noBg"}
                                titulo={"3. Datos del Destino Actual"}
                              ></Titulo>
                              {mostrarDA ? (
                                <>
                                  {}
                                  <div className="datosDestino">
                                    <div className="codPuestoda m-2">
                                      <label htmlFor="puestoda">
                                        Nº cod. puesto:
                                      </label>
                                      <Field
                                        type="text"
                                        id="puestoda"
                                        name="puestoda"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="categoriaDA m-2">
                                      <label htmlFor="cateEspeda">
                                        Categoría/Especialidad:
                                      </label>
                                      <Field
                                        type="text"
                                        id="cateEspeda"
                                        name="cateEspeda"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="grupoProfDA m-2">
                                      <label htmlFor="grupoprofda">
                                        Grupo profesional:
                                      </label>
                                      <Field
                                        type="text"
                                        id="grupoprofda"
                                        name="grupoprofda"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="nivelDA m-2">
                                      <label htmlFor="nivleda">Nivel:</label>
                                      <Field
                                        type="text"
                                        id="nivelda"
                                        name="nivelda"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="consejeriaDA m-2">
                                      <label htmlFor="consejeriada">
                                        Consejería:
                                      </label>
                                      <Field
                                        type="text"
                                        id="consejeriada"
                                        name="consejeriada"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="centroDirectivoda m-2">
                                      <label htmlFor="centrodirectivoda">
                                        Centro directivo:
                                      </label>
                                      <Field
                                        type="text"
                                        id="centrodirectivoda"
                                        name="centrodirectivoda"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="localidadDA m-2">
                                      <label htmlFor="localidadda">
                                        Localidad:
                                      </label>
                                      <Field
                                        type="text"
                                        id="localidadda"
                                        name="localidadda"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="caracterDA m-2">
                                      <label htmlFor="ocupacionda">
                                        Caracter de la ocupación:
                                      </label>
                                      <Field
                                        type="text"
                                        id="ocupacionda"
                                        name="ocupacionda"
                                        className="form-control"
                                        readOnly
                                      />
                                    </div>
                                    <div className="fechaDA m-2">
                                      <label htmlFor="posesionda">
                                        Fecha Toma de posesión:
                                      </label>
                                      <DatePicker
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        name="posesionda"
                                        id="posesionda"
                                        className="form-control col-xxl-4 col-xl-4 col-lg-4 cold-md-4 cold-sm-4"
                                        dateFormat="dd/MM/yyyy"
                                        locale="es"
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <div className="d-flex justify-content-center">
                                  <SpinnerCircle></SpinnerCircle>
                                </div>
                              )}
                              <div className="lugarFechaFirma">
                                <Titulo
                                  clases={"subSubTituloSolicitud p-2 fw-bold"}
                                  tipo={"tituloCard noBg"}
                                  titulo={
                                    "Lugar, Fecha y Firma"
                                  }
                                />
                                <div className="infoFirma">
                                  <p className="ms-2 mb-5">
                                    El abajo firmante declara, bajo su expresa responsabilidad, ser ciertos cuantos datos figuran en la presente solicitud.
                                  </p>
                                  <div className="row d-flex justify-content-center mb-5">
                                    <p className="col-1 text-end">En </p>
                                    <div className="lugarFirma col-3">
                                      <Field
                                        type="text"
                                        id="dprovinciafirma"
                                        name="dprovinciafirma"
                                        className="form-control"
                                        defaultValue={datos?.dprovinciafirma === null ? "" : datos?.dprovinciafirma}
                                      />
                                    </div>

                                    <p className="col-3">, a {fechaFormateada}</p>
                                  </div>
                                  <div className="nombrefirma d-flex justify-content-center">
                                    <p className="fw-bold">Fdo.: {datos?.nombre} {datos?.apellido1} {datos?.apellido2}</p>
                                  </div>
                                </div>
                              </div>
                              <div className="footer p-2">
                                <p>
                                  En cumplimiento de lo dispuesto en la Ley
                                  Orgánica 15/1999, de 13 de diciembre, de
                                  Protección de Datos de Carácter Personal, la
                                  Consejería de Hacienda y Administración
                                  Pública le informa que sus datos personales
                                  obtenidos mediante la cumplimentación de este
                                  documento/impreso/formulario y demás que se
                                  adjunten van a ser incorporados, para su
                                  tratamiento, en un fichero automatizado que
                                  tratará los datos de todos los participantes
                                  en la convocación conforme al procedimiento
                                  establecido en la misma. De acuerdo con lo
                                  previsto en la citada Ley Orgánica, pude
                                  ejercitar los derechos de acceso,
                                  rectificación o cancelación y oposición ante
                                  el órgano correspondiente.
                                </p>
                                <p>
                                  (1) Si posee más de una categoría /
                                  especialidad y va a participar por más de una
                                  de ellas, deberá usar este campo para indicar
                                  el orden de preferencia de esta solicitud
                                  entre todas las que presente para esta
                                  convocatoria.
                                </p>
                              </div>
                              <div className="mb-2 gridBotones">
                                <button
                                  id="guardarAnexoi1"
                                  className="btnRed rounded m-2 btnCancelar"
                                  type="button"
                                  onClick={() =>
                                    setShow({
                                      mensaje: true,
                                      content:
                                        "¿Deseas cancelar el formulario?",
                                      tipo: "tituloModal",
                                      aviso: true,
                                      destinoAviso: `/concurso/${params?.idcon}`,
                                    })
                                  }
                                >
                                  <i className="fa-solid fa-cancel"></i>{" "}
                                  Cancelar
                                </button>

                                <button
                                  id="grabarAnexoii1"
                                  className="btn m-2 btnPresentar"
                                  type="submit"
                                  onClick={() => {
                                    // }`)
                                    setCargaBoton(true);
                                    if (!comprobarDatos(errors)) {
                                      
                                      
                                      setShow({
                                        mensaje: true,
                                        content:
                                          "Es necesario completar los datos obligatorios.",
                                        tipo: "tituloModal rojo",
                                        destinoCerrar: null,
                                      });
                                      setCargaBoton(false);
                                    }
                                  }}
                                  disabled={
                                    // borrador === false && !disablePresentar
                                    !disableGuardar
                                      ? !disableGuardar
                                      : disableGuardar
                                        ? cargaBoton
                                        : false
                                  }
                                >
                                  {cargaBoton ? (
                                    <>
                                      <div className="d-flex justify-content-center">
                                        <SpinnerCircleMini
                                          clases={"background-border"}
                                        ></SpinnerCircleMini>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <i className="fa-solid fa-save"></i>{" "}
                                      Guardar Borrador
                                    </>
                                  )}
                                </button>
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : !datos.toString().startsWith("Error:") ? (
          <>
            <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              <SpinnerCircle></SpinnerCircle>
            </div>
          </>
        ) : (
          <>
            <div className="error fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              <IfError
                mensage="Error: Fallo en intentar obtener los datos de usuario."
                ruta="/home"
              ></IfError>
            </div>
          </>
        )}
      </div>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.content}
          tipo={show.tipo}
          aviso={show.aviso}
          destinoAviso={show.destinoAviso}
          otherContent={show.otherContent}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
      <Footer></Footer>
    </>
  );
};
export default AnexoI1;
